<geaui-page-content-layout class="users-editor-page">
  <ng-container page-header>
    <geaui-page-header
      [pageTitle]="userPersonalDataForm.value.userName || 'New User'"
      [hasBackArrow]="true"
      [withSidebar]="true"
      [isLoading]="isUserLoading"
      (backArrowClicked)="goBack()"
    >
      <div class="users-editor-page-header-container">
        <geaui-tab-menu-v2
          [tabItems]="tabMenuItems"
          [activeItem]="activeTabItem"
          [type]="'ghost'"
          [size]="'medium'"
          (activeItemChange)="goToTab($event)"
        ></geaui-tab-menu-v2>
      </div>
    </geaui-page-header>
  </ng-container>

  <ng-container page-content>
    <div class="users-editor-content">
      @if (activeTabItem.tabindex == "0") {
        <div class="gea-font-heading-20" style="margin: 0 40px">
          Personal Data
        </div>
        <div
          class="user-personal-data column-style geaui-grid geaui-sidebar-grid geaui-scrollable-table"
        >
          <geaui-input-v3
            label="Name"
            [formGroup]="userPersonalDataForm"
            [formFieldName]="'userName'"
            [canClear]="true"
            [type]="'text'"
            [size]="'large'"
            [loading]="isUserLoading"
            [required]="true"
            [fieldError]="'Name is required'"
            [value]="userPersonalDataForm.get('userName')?.value ?? ''"
          ></geaui-input-v3>
          <geaui-input-v3
            label="Email"
            [formGroup]="userPersonalDataForm"
            [formFieldName]="'email'"
            [canClear]="true"
            [type]="'mail'"
            [size]="'large'"
            [loading]="isUserLoading"
            [required]="true"
            [fieldError]="'Valid email is required'"
            [value]="userPersonalDataForm.get('email')?.value ?? ''"
          ></geaui-input-v3>
          <geaui-input-v3
            label="Last Login"
            [formGroup]="userPersonalDataForm"
            [formFieldName]="'lastLogin'"
            [type]="'text'"
            [size]="'large'"
            [disabled]="true"
            [loading]="isUserLoading"
            [value]="userPersonalDataForm.get('lastLogin')?.value ?? ''"
          ></geaui-input-v3>
        </div>
      } @else if (activeTabItem.tabindex == "1") {
        <div class="gea-font-heading-20" style="margin: 0 40px">
          Permissions
        </div>
        <div
          class="user-personal-data data-section geaui-grid geaui-sidebar-grid geaui-scrollable-table"
        >
          <geaui-autocomplete-select-v3
            [label]="'Role'"
            [floatLabelType]="'always'"
            [options]="permissionsList"
            [formGroup]="userPermissionsForm"
            [formFieldName]="'role'"
            [value]="userPermissionsForm.get('role')?.value"
            [required]="true"
            (valueChange)="onRoleChange($event)"
          ></geaui-autocomplete-select-v3>
        </div>
        <table class="permissions-table">
          <tr>
            <td class="label-column"><b>App Feature</b></td>
            <td class="checkbox-column"><b>View</b></td>
            <td class="checkbox-column"><b>Edit</b></td>
            <td class="checkbox-column"><b>Custom</b></td>
          </tr>
          <tr *ngFor="let permission of permissions">
            <td class="label-column">{{ permission.Name }}</td>
            <td class="checkbox-column">
              <mat-checkbox
                [(ngModel)]="permission.CanView"
                (onChange)="viewChanged(permission)"
                [disabled]="permission.Name == 'Home'"
              ></mat-checkbox>
            </td>
            <td class="checkbox-column">
              <mat-checkbox
                *ngIf="FeatureHasEdit(permission.Id)"
                [(ngModel)]="permission.CanEdit"
                (ngModelChange)="editChanged(permission)"
              ></mat-checkbox>
            </td>
            <td class="checkbox-column">
              <mat-checkbox
                *ngIf="FeatureHasCustomPermission(permission.Id)"
                [(ngModel)]="permission.CustomPermission"
                (ngModelChange)="customPermissionChanged(permission)"
              ></mat-checkbox>
            </td>
          </tr>
        </table>

        <div class="gea-font-heading-20" style="margin: 40px 0 0 40px">
          Filters
        </div>
        @if (isNew) {
          <div
            class="user-order-status column-style geaui-grid geaui-sidebar-grid geaui-scrollable-table"
          >
            @if (isOrderStatusFilterVisible) {
              <geaui-input-v3
                label="Order Status Filter"
                [formGroup]="userPersonalDataForm"
                [formFieldName]="'orderStatusFilter'"
                [canClear]="true"
                [required]="isExternalSalesRoleSelected"
                [fieldError]="'Order Status Filter is required'"
                [type]="'text'"
                [size]="'large'"
                [loading]="isUserLoading"
                [value]="
                  userPersonalDataForm.get('orderStatusFilter')?.value ?? ''
                "
              ></geaui-input-v3>
            }
            @if (isSiteFilterVisible) {
              <geaui-input-v3
                label="Site Filter"
                [formGroup]="userPersonalDataForm"
                [formFieldName]="'siteFilter'"
                [canClear]="true"
                [required]="isCustomerRoleSelected"
                [fieldError]="'Site Filter is required'"
                [type]="'text'"
                [size]="'large'"
                [loading]="isUserLoading"
                [value]="userPersonalDataForm.get('siteFilter')?.value ?? ''"
              ></geaui-input-v3>
            }
          </div>
        } @else {
          <div
            class="user-order-status column-style geaui-grid geaui-sidebar-grid geaui-scrollable-table"
          >
            <geaui-input-v3
              label="Order Status Filter"
              [formGroup]="userPersonalDataForm"
              [formFieldName]="'orderStatusFilter'"
              [canClear]="true"
              [required]="isExternalSalesRoleSelected"
              [fieldError]="'Order Status Filter is required'"
              [type]="'text'"
              [size]="'large'"
              [loading]="isUserLoading"
              [value]="
                userPersonalDataForm.get('orderStatusFilter')?.value ?? ''
              "
            ></geaui-input-v3>
            <geaui-input-v3
              label="Site Filter"
              [formGroup]="userPersonalDataForm"
              [formFieldName]="'siteFilter'"
              [canClear]="true"
              [required]="isCustomerRoleSelected"
              [fieldError]="'Site Filter is required'"
              [type]="'text'"
              [size]="'large'"
              [loading]="isUserLoading"
              [value]="userPersonalDataForm.get('siteFilter')?.value ?? ''"
            ></geaui-input-v3>
          </div>
        }
      } @else if (activeTabItem.tabindex == "2") {
        <div class="gea-font-heading-20" style="margin: 0 40px">
          Notifications
        </div>
        <div
          class="user-notifications-section data-section geaui-grid geaui-sidebar-grid geaui-scrollable-table"
        >
          <geaui-autocomplete-select-v3
            [label]="'Order Status Notification Name'"
            [formGroup]="userPersonalDataForm"
            [formFieldName]="'orderStatusNotificationName'"
            [loading]="isUserLoading"
            [options]="orderStatusData"
            [floatLabelType]="'always'"
            [placeholder]="'Select - Order Status Notification Name'"
            (valueChange)="
              onOrderStatusNameChange($event, 'orderStatusNotificationName')
            "
          ></geaui-autocomplete-select-v3>
        </div>
        <geaui-button-v3
          (click)="addNotification()"
          [type]="'primary'"
          [style]="'margin: 0 0 40px 40px;'"
          >Add Notification</geaui-button-v3
        >
        <table class="permissions-table">
          <tr>
            <td class="checkbox-column"><b>Type</b></td>
            <td class="checkbox-column"><b>Resource</b></td>
            <td></td>
          </tr>
          <tr *ngFor="let notification of notifications">
            <td>
              <mat-form-field class="data-control-long">
                <mat-label>Role</mat-label>
                <mat-select [(value)]="notification.TypeId">
                  <mat-optgroup>
                    <mat-option
                      *ngFor="let type of userNotificationTypes"
                      [value]="type.Id"
                      >{{ type.Name }}</mat-option
                    >
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field
                class="data-control-long"
                *ngIf="notification.TypeId == 1"
              >
                <mat-label>Company</mat-label>
                <mat-select [(value)]="notification.ForeignKey">
                  <mat-optgroup>
                    <mat-option
                      *ngFor="let company of companies"
                      [value]="company.Id"
                      >{{ company.Name }}</mat-option
                    >
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                class="data-control-long"
                *ngIf="notification.TypeId == 2"
              >
                <mat-label>Product</mat-label>
                <mat-select [(value)]="notification.ForeignKey">
                  <mat-optgroup>
                    <mat-option
                      *ngFor="let application of applications"
                      [value]="application.Id"
                      >{{ application.Name }}</mat-option
                    >
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
              <mat-form-field *ngIf="notification.TypeId == 4">
                <mat-label>Site ID</mat-label>
                <input matInput [(ngModel)]="notification.ForeignKey" />
              </mat-form-field>
            </td>
            <td>
              <button (click)="deleteNotification(notification)">Delete</button>
            </td>
          </tr>
        </table>
      }
    </div>
  </ng-container>

  <ng-container page-footer>
    <geaui-page-footer [withSidebar]="true">
      <ng-container footer-button>
        <geaui-button-v3 (click)="save()" [type]="'primary'"
          >Save</geaui-button-v3
        >
      </ng-container>
    </geaui-page-footer>
  </ng-container>
</geaui-page-content-layout>
